async function getUserLocation() {
	let response
	try {
		response = await fetch('https://ipinfo.io/json')
	} catch (error) {
		console.error(`An error occurred while fetching ipinfo: ${error}`)
	}

	if (!response?.ok) return

	return await response.json()
}

document.addEventListener('DOMContentLoaded', async () => {
	const overlayEl = document.getElementById('geolocation-overlay')
	const modalEl = document.getElementById('geolocation-modal')

	if (!overlayEl || !modalEl) return

	const siteUrls = {
		ce: 'https://distribution.audio-technica.eu/ce/',
		fr: 'https://distribution.audio-technica.eu/fr-fr/',
		de: 'https://distribution.audio-technica.eu/de-de/',
		nl: 'https://distribution.audio-technica.eu/nl-nl/',
		es: 'https://distribution.audio-technica.eu/es-es/',
		gb: 'https://distribution.audio-technica.eu/en-gb/',
		at: 'https://distribution.audio-technica.eu/de-at/',
	}

	const path = window.location.pathname
	const currentSiteKey = path.startsWith('/ce/') ? 'ce'
		: path.startsWith('/fr-fr/') ? 'fr'
		: path.startsWith('/de-de/') ? 'de'
		: path.startsWith('/nl-nl/') ? 'nl'
		: path.startsWith('/es-es/') ? 'es'
		: path.startsWith('/en-gb/') ? 'gb'
		: path.startsWith('/de-at/') ? 'at'
		: null

	if (!currentSiteKey) return

	// namespace the storage key
	const STORAGE_KEY = `at_geolocationConfirmed_${currentSiteKey}`

	const isConfirmationValid = () => {
		const storedValue = localStorage.getItem(STORAGE_KEY)
		if (!storedValue) return false

		try {
			const storedValueData = JSON.parse(storedValue)
			if (!storedValueData.timestamp || typeof storedValueData.timestamp !== 'number') return false
			const ageDays = (Date.now() - storedValueData.timestamp) / (1000 * 60 * 60 * 24)
			return ageDays <= 7
		} catch {
			return false
		}
	}

	if (isConfirmationValid()) return

	const userLocation = await getUserLocation()
	if (!userLocation?.country) return

	const countryToSite = { GB: 'gb', FR: 'fr', DE: 'de', NL: 'nl', ES: 'es', AT: 'at' }

	const centralEuropeCountries = ['BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'PL', 'PT', 'RO', 'SK', 'SI', 'SE', 'AL', 'AD', 'AM', 'BY', 'BA', 'FO', 'GE', 'GI', 'IS', 'IM', 'XK', 'LI', 'MK', 'MD', 'MC', 'ME', 'NO', 'RU', 'SM', 'RS', 'CH', 'TR', 'UA', 'VA']

	const getSuggestedSite = (countryCode) => {
		if (countryToSite[countryCode]) return countryToSite[countryCode]
		if (centralEuropeCountries.includes(countryCode)) return 'ce'
		return null
	}

	const suggestedSite = getSuggestedSite(userLocation.country)

	if (!suggestedSite || suggestedSite === currentSiteKey) return

	const siteDisplayNames = { gb: 'UK', fr: 'France', de: 'Germany', nl: 'Netherlands', es: 'Spain', at: 'Austria', ce: 'CE' }
	const countriesWithArticle = ['GB', 'NL']

	let countryName = userLocation.country
	try {
		countryName = new Intl.DisplayNames(['en'], { type: 'region' }).of(userLocation.country)
	} catch {}

	if (userLocation.country === 'GB') countryName = 'UK'

	if(countriesWithArticle.includes(userLocation.country)) {
		countryName = `the ${countryName}`
	}

	const replacePlaceholders = el => {
		if (!el) return
		el.innerHTML = el.innerHTML.replace(/{country}/g, countryName).replace('the the', 'the')
	}

	replacePlaceholders(modalEl.querySelector('.js-geolocation-title'))
	replacePlaceholders(modalEl.querySelector('.js-geolocation-content'))

	const siteCodeLabels = { gb: 'UK' }
	const redirectBtn = modalEl.querySelector('.js-geolocation-redirect-button')
	const buttonLabel = siteCodeLabels[suggestedSite] ?? suggestedSite.toUpperCase()
	replacePlaceholders(redirectBtn, buttonLabel, buttonLabel)
	if (redirectBtn) {
		redirectBtn.href = siteUrls[suggestedSite]
	}

	const focusableSelectors = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
	const previouslyFocusedEl = document.activeElement
	const stayBtn = modalEl.querySelector('.js-geolocation-stay-button')

	const getFocusableEls = () => Array.from(modalEl.querySelectorAll(focusableSelectors))

	const trapFocus = (e) => {
		if (e.key !== 'Tab') return
		const focusable = getFocusableEls()
		if (!focusable.length) return
		const first = focusable[0]
		const last = focusable[focusable.length - 1]
		if (e.shiftKey) {
			if (document.activeElement === first) { e.preventDefault(); last.focus() }
		} else {
			if (document.activeElement === last) { e.preventDefault(); first.focus() }
		}
	}

	const handleOverlayClick = (e) => {
		if (e.target === overlayEl) closeModal()
	}

	const closeModal = () => {
		overlayEl.classList.remove('active')
		overlayEl.classList.add('closing')
		overlayEl.setAttribute('aria-hidden', 'true')
		document.removeEventListener('keydown', trapFocus)
		document.removeEventListener('keydown', handleEscape)
		overlayEl.removeEventListener('click', handleOverlayClick)
		stayBtn?.removeEventListener('click', closeModal)
		localStorage.setItem(STORAGE_KEY, JSON.stringify({ timestamp: Date.now() }))
		previouslyFocusedEl?.focus()
		setTimeout(() => overlayEl.classList.remove('closing'), 350)
	}

	const handleEscape = (e) => {
		if (e.key === 'Escape') closeModal()
	}

	overlayEl.classList.add('active')
	overlayEl.removeAttribute('aria-hidden')
	document.addEventListener('keydown', trapFocus)
	document.addEventListener('keydown', handleEscape)
	overlayEl.addEventListener('click', handleOverlayClick)
	stayBtn?.addEventListener('click', closeModal)

	const firstFocusable = getFocusableEls()?.[0]

	(firstFocusable ?? modalEl).focus()
})
